<script lang="ts">
	import StaticPicture from "./Picture/StaticPicture.svelte";
	export let content = "";
	export let author = "";
	export let role = "";
	export let img = "";
</script>

<div class="max-w-[23.68rem] rounded-lg bg-[#202020] p-8">
	<StaticPicture
		imgClass="border-primary border-2 rounded-full z-30 mb-4"
		width={83}
		height={83}
		image={img}
		alt={author}
	/>
	<p class="text-xs">
		{content}
	</p>
	<p class="text-3xs mb-0 font-bold text-[#727272]">{author}</p>
	<p class="text-3xs mb-0 font-medium text-[#727272]">{role}</p>
</div>
